import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2214f894"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "gap-10" }
const _hoisted_2 = { class: "radio-stack gap-10" }
const _hoisted_3 = { class: "tips-row tips-row-with-icon cm-align-center" }
const _hoisted_4 = { class: "process-tips" }
const _hoisted_5 = { class: "process-tips-header" }
const _hoisted_6 = { class: "info-item" }
const _hoisted_7 = { class: "info-header" }
const _hoisted_8 = { class: "info-row" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "wildcard-sym" }, "*", -1))
const _hoisted_10 = { class: "info-row" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "wildcard-sym" }, "?", -1))
const _hoisted_12 = { class: "info-item" }
const _hoisted_13 = { class: "info-header" }
const _hoisted_14 = { class: "info-row" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "wildcard-sym" }, "*", -1))
const _hoisted_16 = { class: "info-row" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "wildcard-sym" }, "?", -1))
const _hoisted_18 = { class: "info-row" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "wildcard-sym" }, "**", -1))
const _hoisted_20 = { class: "policy-bind-wrap" }
const _hoisted_21 = { class: "button-group" }

import { computed, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { ElMessage } from 'element-plus'
import CmForm from '@/components/cmForm/index.vue'
import { FormActionType, FormSize, FormType } from '@/components/cmForm/types'
import { formLabelStyle } from '@/components/cmForm/globalOpt'
import ContentAdaptLayout from '@/views/dashboard/_components/content-adapt-layout/content-adapt-layout.vue'
import TaskTimeEdit from '@/views/dashboard/_components/task-time/task-time-edit.vue'
import type { TaskTimeSetting } from '@/views/dashboard/_components/task-time/task-time.service'
import SoftwareSelect from '@/views/dashboard/_components/software-select/software-select.vue'
import PolicyBindScope from '@/views/dashboard/policy/_components/policy-bind-scope.vue'
import { policyBindScopeFormRules } from '@/views/dashboard/policy/_components/policy-bind-scope-form-rule'
import {
  DEFAULT_SETTING,
  defaultSoftwareDisabledProcessRow,
  SettingsRes,
} from '@/views/dashboard/policy/software-disabled-edit/software-disabled-edit.service'
import type { SoftwareDisabledProcessInfo } from '@/views/dashboard/policy/software-disabled/software-disabled.service'
import { editToList, PolicyCommonService } from '@/views/dashboard/policy/policy-common.service'
import { PermissionFe } from '@/services/service-permission.service'
import { PolicySettingType, PolicyType } from '@/views/dashboard/_enum/policy-type'

const SCENE_INSTALL = 'install'
const SCENE_RUN = 'run'
const SCENE_UPDATE = 'update'

type SoftwareDisabledEditForm = {
  name: string
  bind_mode: number
  device_ids: string[]
  strategy_group_ids: string[]
  main_switch: boolean
  handle_type: number
  interval_type: number
  frequency: number
  regular_tasks: TaskTimeSetting[]
  software_ids: number[]
  process_infos: SoftwareDisabledProcessInfo[]
  scenes: string[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'software-disabled-edit',
  props: {
    drawerMode: { type: Boolean, default: false },
    initialPolicyId: { default: '' },
    initialFromGroupId: { default: undefined },
    policyId: { default: '' },
    fromGroupId: { default: undefined },
    readonly: { type: Boolean, default: false }
  },
  emits: ["close", "success"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const { t, locale } = useI18n()
const injector = useReflectiveInjector([PolicyCommonService])
const policyCommonService = injector.get(PolicyCommonService)

/** 策略应用场景值 */
function createDefaultForm(): SoftwareDisabledEditForm {
  const s = JSON.parse(JSON.stringify(DEFAULT_SETTING)) as typeof DEFAULT_SETTING & {
    regular_tasks?: TaskTimeSetting[]
    process_infos?: SoftwareDisabledProcessInfo[]
  }
  return {
    name: '',
    bind_mode: 0,
    device_ids: [],
    strategy_group_ids: [],
    main_switch: s.main_switch,
    handle_type: s.handle_type,
    interval_type: s.interval_type,
    frequency: s.frequency,
    regular_tasks: s.regular_tasks?.length ? [...s.regular_tasks] : [...(DEFAULT_SETTING.regular_tasks || [])],
    software_ids: [...(s.software_ids || [])],
    process_infos:
      Array.isArray(s.process_infos) && s.process_infos.length
        ? s.process_infos.map((row) => ({
          name: String(row.name ?? ''),
          path: String(row.path ?? ''),
          md5: String(row.md5 ?? ''),
          signature: String(row.signature ?? ''),
        }))
        : [defaultSoftwareDisabledProcessRow()],
    scenes: Array.isArray(s.scenes) ? [...s.scenes] : [],
  }
}

const isLoading = ref(false)
const cmFormRef = ref<InstanceType<typeof CmForm>>()
const form = ref<SoftwareDisabledEditForm>(createDefaultForm())
/** 目标进程表显隐；有已填数据时加载策略后自动展开 */
const showProcessInfosSection = ref(false)

const resolvedPolicyId = computed(() =>
  props.drawerMode ? (props.initialPolicyId || '') : (props.policyId || ''),
)
const resolvedFromGroupId = computed(() =>
  props.drawerMode ? (props.initialFromGroupId || undefined) : (props.fromGroupId || undefined),
)
const presetGroupIdForPolicyBind = computed(() => {
  if (resolvedPolicyId.value) return undefined
  const id = resolvedFromGroupId.value
  if (id == null || id === '') return undefined
  const n = Number(id)
  return Number.isFinite(n) ? n : undefined
})
const isReadonly = computed(() => (props.drawerMode ? false : props.readonly))

const groupEditStrategyOver = computed(() => ({
  type: PolicyType.softwareDisabled,
  current: resolvedPolicyId.value,
}))

const globalOpt = { required: true }

const cmFormOpt = {
  labelPosition: 'left' as const,
  labelWidth: '180px',
  hideRequiredAsterisk: true,
}

function validateProcessPath(_rule: unknown, value: string, callback: (e?: Error) => void) {
  if (
    form.value.main_switch &&
    Array.isArray(form.value.software_ids) &&
    form.value.software_ids.length > 0
  ) {
    callback()
    return
  }
  if (value == null || String(value).trim() === '') {
    callback()
    return
  }
  const reg =
    /^[a-zA-Z]:(\/|\\)(?:[^/\\:*?"<>|\r\n]+(?:\/|\\)[^/\\:*?"<>|\r\n]+)*[^/\\:*?"<>|\r\n]+$/
  if (!reg.test(String(value))) {
    callback(new Error(t('softwareDisabledEdit.processPathInvalid')))
  } else {
    callback()
  }
}

function validateSoftwareIds(_rule: unknown, value: number[], callback: (e?: Error) => void) {
  if (!form.value.main_switch) {
    callback()
    return
  }
  if (processInfosHasMeaningfulData(form.value.process_infos)) {
    callback()
    return
  }
  if (Array.isArray(value) && value.length > 0) {
    callback()
    return
  }
  callback(new Error(t('screenWatermark.selectTargetSoft')))
}

function validateScenes(_rule: unknown, value: string[], callback: (e?: Error) => void) {
  if (!form.value.main_switch) {
    callback()
    return
  }
  if (Array.isArray(value) && value.length > 0) {
    callback()
    return
  }
  callback(new Error(t('softwareDisabledEdit.scenesRequired')))
}

const processTableDisabled = () => !form.value.main_switch

function processInfosHasMeaningfulData(rows: SoftwareDisabledProcessInfo[]) {
  return rows.some((r) =>
    [r.name, r.path, r.md5, r.signature].some((f) => String(f ?? '').trim() !== ''),
  )
}

function toggleProcessInfosSection() {
  showProcessInfosSection.value = !showProcessInfosSection.value
}

const formColumns = computed(() => {
  void locale.value
  void showProcessInfosSection.value
  const cols: any[] = [
    {
      prop: 'name',
      label: t('screenWatermark.policyName'),
      colOpt: { span: 12 },
      modelModifiers: { trim: true },
      rules: [{ required: true, message: t('screenWatermark.pleaseEnterPolicyName'), trigger: 'blur' }],
      inputOpt: { maxlength: 50, size: 'small', },
      disabled: processTableDisabled,
    },
    {
      prop: 'scenes',
      type: FormType.CheckboxGroup,
      label: t('softwareDisabledEdit.scenesLabel'),
      footerSlot: true,
      colOpt: { span: 24 },
      formItemOpt: { class: 'label-line' },
      required: false,
      globalOpt: { required: false },
      dictData: [
        { label: t('softwareDisabledEdit.sceneInstall'), value: SCENE_INSTALL },
        { label: t('softwareDisabledEdit.sceneRun'), value: SCENE_RUN },
        { label: t('softwareDisabledEdit.sceneUpdate'), value: SCENE_UPDATE },
      ],
      disabled: processTableDisabled,
      rules: [
        {
          required: false,
          custom: { validator: validateScenes, trigger: 'change' },
        },
      ],
    },
    {
      prop: 'handle_type',
      label: t('softwareDisabledEdit.handleTypeLabel'),
      slot: true,
      colOpt: { span: 24 },
      formItemOpt: { class: 'label-line' },
      required: false,
      globalOpt: { required: false },
    },
    {
      prop: 'interval_type',
      label: t('softwareDisabledEdit.listAttrLabel'),
      slot: true,
      colOpt: { span: 24 },
      formItemOpt: { class: 'label-line' },
      required: false,
      globalOpt: { required: false },
    },
    {
      prop: 'frequency',
      label: t('remoteAuth.policyExecuteFreq'),
      type: FormType.Select,
      colOpt: { span: 12 },
      dictData: [
        { label: t('softwareDisabledEdit.freqDaily'), value: 1 },
        { label: t('softwareDisabledEdit.freqWeekly'), value: 2 },
        { label: t('softwareDisabledEdit.freqMonthly'), value: 3 },
      ],
      selectOpt: { size: 'small' },
      disabled: processTableDisabled,
      events: {
        change: () => {
          form.value.regular_tasks = [...(DEFAULT_SETTING.regular_tasks || [])]
        },
      },
    },
    {
      prop: 'regular_tasks',
      label: t('remoteAuth.policyExecuteTime'),
      slot: true,
      colOpt: { span: 24 },
      required: false,
      globalOpt: { required: false },
    },
    {
      prop: 'software_ids',
      label: t('screenWatermark.targetSoftware'),
      slot: true,
      footerSlot: true,
      colOpt: { span: 24 },
      required: false,
      globalOpt: { required: false },
      rules: [
        {
          required: false,
          custom: { validator: validateSoftwareIds, trigger: 'change' },
        },
      ],
    },
    {
      prop: 'process_infos',
      type: FormType.DynamicTable,
      label: t('softwareDisabledEdit.targetProcess'),
      hidden: () => !showProcessInfosSection.value,
      colOpt: { span: 24,style:'margin: -30px 0 15px' },
      tableOpt: {
        'max-height': 400,
        bodyStyle: 'line-height: normal;padding: 6px',
        cardOpt: { style: 'margin-top: 7px' },
      },
      required: false,
      hiddenAllLabel: true,
      plusText: t('softwareDisabledEdit.addProcess'),
      removeText: t('softwareDisabledEdit.removeProcess'),
      removeOpt: { type: 'danger', underline: false },
      plusOpt: { style: 'margin-top:10px', type: 'primary', plain: true },
      rowAdd: (done: (row: SoftwareDisabledProcessInfo) => void) => {
        done(defaultSoftwareDisabledProcessRow())
      },
      rowDel: (_row: unknown, done: () => void) => done(),
      columns: {
        name: {
          hiddenAllLabel: true,
          label: t('softwareDisabledEdit.processName'),
          placeholder: t('softwareDisabledEdit.processNamePlaceholder'),
          disabled: processTableDisabled,
          inputOpt: { size: 'small' },
        },
        path: {
          hiddenAllLabel: true,
          label: t('softwareDisabledEdit.pathLabel'),
          placeholder: t('softwareDisabledEdit.pathPlaceholder'),
          disabled: processTableDisabled,
          rules: [{ custom: { validator: validateProcessPath } }],
          inputOpt: { size: 'small' },
        },
        md5: {
          hiddenAllLabel: true,
          label: t('softwareDisabledEdit.md5Label'),
          placeholder: t('softwareDisabledEdit.optionalPlaceholder'),
          disabled: processTableDisabled,
          inputOpt: { size: 'small' },
        },
        signature: {
          hiddenAllLabel: true,
          label: t('softwareDisabledEdit.signatureLabel'),
          placeholder: t('softwareDisabledEdit.optionalPlaceholder'),
          disabled: processTableDisabled,
          inputOpt: { size: 'small' },
        },
      },
    },
    {
      prop: 'strategy_group_ids',
      label: t('policyBindScope.applyMode'),
      slot: true,
      labelSlot: true,
      colOpt: { span: 24 },
      required: false,
      formItemOpt: { required: false, class: 'label-line' },
      rules: policyBindScopeFormRules(
        () => ({
          bind_mode: form.value.bind_mode,
          group_ids: form.value.strategy_group_ids,
          device_ids: form.value.device_ids,
        }),
        t,
      ),
    },
  ]
  return cols
})

function onSoftwareIdsUpdate(e: number[]) {
  form.value.software_ids = e
  cmFormRef.value?.ruleFormRef?.validateField('software_ids')
}

function onGroupScopeUpdate() {
  cmFormRef.value?.ruleFormRef?.validateField('strategy_group_ids')
}

function settingsResToForm(res: SettingsRes): SoftwareDisabledEditForm {
  const s = res.strategy
  let process_infos: SoftwareDisabledProcessInfo[]
  if (!Array.isArray(s.process_infos) || s.process_infos.length === 0) {
    process_infos = [defaultSoftwareDisabledProcessRow()]
  } else {
    process_infos = s.process_infos.map((row) => ({
      name: String(row.name ?? ''),
      path: String(row.path ?? ''),
      md5: String(row.md5 ?? ''),
      signature: String(row.signature ?? ''),
    }))
  }
  return {
    name: res.name ?? '',
    bind_mode: res.bind_mode ?? 0,
    device_ids: res.device_ids ?? [],
    strategy_group_ids: (res.strategy_group_ids ?? []).map(String),
    main_switch: s.main_switch,
    handle_type: s.handle_type,
    interval_type: s.interval_type,
    frequency: s.frequency,
    regular_tasks: s.regular_tasks?.length ? [...s.regular_tasks] : [...(DEFAULT_SETTING.regular_tasks || [])],
    software_ids: [...(s.software_ids || [])],
    process_infos,
    scenes: Array.isArray(s.scenes) ? [...s.scenes] : [],
  }
}

function formToStrategyPayload(): string {
  const f = form.value
  return JSON.stringify({
    main_switch: f.main_switch,
    handle_type: f.handle_type,
    interval_type: f.interval_type,
    frequency: f.frequency,
    regular_tasks: f.regular_tasks,
    software_ids: f.software_ids,
    process_infos: f.process_infos,
    scenes: f.scenes,
  })
}

function getSettings() {
  isLoading.value = true
  policyCommonService
    .getSettings({
      id: resolvedPolicyId.value,
      type: PolicySettingType.softwareDisabled,
    })
    .then((response) => {
      form.value = settingsResToForm(response)
      showProcessInfosSection.value = processInfosHasMeaningfulData(form.value.process_infos)
    })
    .finally(() => {
      isLoading.value = false
    })
}

async function saveSetting() {
  const valid = await cmFormRef.value?.handleSubmit?.()
  if (!valid) {
    ElMessage.error(t('screenWatermark.formError'))
    return
  }
  policyCommonService
    .saveSettings({
      id: resolvedPolicyId.value,
      strategy: formToStrategyPayload(),
      name: form.value.name,
      group_ids: form.value.strategy_group_ids ?? [],
      device_ids: form.value.device_ids,
      bind_mode: form.value.bind_mode ?? 0,
      type: PolicySettingType.softwareDisabled,
      strategy_type: PolicyType.softwareDisabled,
    })
    .then(() => {
      ElMessage.success(t('softwareDisabledEdit.saveSuccess'))
      emit('success')
    })
}

function cancel() {
  emit('close')
}


watch(
  resolvedPolicyId,
  (id) => {
    if (id) {
      getSettings()
    } else {
      showProcessInfosSection.value = false
    }
  },
  { immediate: true },
)

watch(
  () => form.value.process_infos,
  () => {
    cmFormRef.value?.ruleFormRef?.validateField('software_ids')
  },
  { deep: true },
)

watch(
  () => form.value.software_ids,
  () => {
    form.value.process_infos.forEach((_, i) => {
      cmFormRef.value?.ruleFormRef?.validateField(`process_infos.${i}.path`)
    })
  },
  { deep: true },
)

return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(ContentAdaptLayout, { style: {"padding":"20px","box-sizing":"border-box"} }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_21, [
        _createVNode(_component_el_button, {
          size: "small",
          onClick: cancel
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          disabled: isReadonly.value,
          class: "cm-ui-ml10",
          size: "small",
          type: "primary",
          onClick: saveSetting
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(CmForm, {
        ref_key: "cmFormRef",
        ref: cmFormRef,
        class: _normalizeClass({ readonly: isReadonly.value }),
        "form-size": _unref(FormSize).Small,
        modelValue: form.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form).value = $event)),
        "form-type": _unref(FormActionType).Other,
        "onUpdate:formType": _cache[7] || (_cache[7] = ($event: any) => ((_unref(FormActionType).Other) = $event)),
        "form-columns": formColumns.value,
        "form-opt": cmFormOpt,
        "global-opt": globalOpt,
        "row-opt": { style: { display: 'grid' }, class: 'gap-20' },
        "ope-row-opt": { style: { display: 'none' } },
        disabled: isReadonly.value
      }, {
        handle_type: _withCtx(() => [
          _createVNode(_component_el_radio_group, {
            modelValue: form.value.handle_type,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.handle_type) = $event)),
            modelModifiers: { number: true },
            disabled: !form.value.main_switch
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_el_radio, {
                  class: "sub-row",
                  label: 0
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('softwareDisabledLog.triggerResultDesc0')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  class: "sub-row",
                  label: 1
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('softwareDisabledLog.triggerResultDesc1')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  class: "sub-row",
                  label: 2
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('softwareDisabledLog.triggerResultDesc2')), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"])
        ]),
        interval_type: _withCtx(() => [
          _createVNode(_component_el_radio_group, {
            modelValue: form.value.interval_type,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.interval_type) = $event)),
            modelModifiers: { number: true },
            disabled: !form.value.main_switch
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_el_radio, {
                  class: "sub-row",
                  label: 1
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('softwareDisabledLog.blacklist')), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"])
        ]),
        regular_tasks: _withCtx(() => [
          _createVNode(TaskTimeEdit, {
            modelValue: form.value.regular_tasks,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.regular_tasks) = $event)),
            "main-switch": form.value.main_switch,
            "mix-type": form.value.frequency,
            "default-end-min": 23 * 60 + 50
          }, null, 8, ["modelValue", "main-switch", "mix-type"])
        ]),
        software_ids: _withCtx(() => [
          _createVNode(SoftwareSelect, {
            disabled: !form.value.main_switch,
            "model-value": form.value.software_ids,
            placeholder: _ctx.$t('screenWatermark.selectTargetSoft'),
            onUpdate: onSoftwareIdsUpdate
          }, null, 8, ["disabled", "model-value", "placeholder"])
        ]),
        "software_ids-footer": _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, [
              _createTextVNode(_toDisplayString(_ctx.$t('screenWatermark.selectedCount', { n: form.value.software_ids.length })) + " " + _toDisplayString(_ctx.$t('softwareDisabledEdit.processSectionHintBefore')) + " ", 1),
              _createVNode(_component_el_button, {
                type: "text",
                size: "small",
                disabled: !form.value.main_switch,
                onClick: toggleProcessInfosSection
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(showProcessInfosSection.value
                  ? _ctx.$t('softwareDisabledEdit.collapseTargetRunningProcess')
                  : _ctx.$t('softwareDisabledEdit.addTargetRunningProcess')), 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _createVNode(_component_el_tooltip, {
              placement: "bottom-start",
              effect: "light",
              "popper-class": "software-disabled-wildcard-tooltip"
            }, {
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('softwareDisabledEdit.wildcardRulesTitle')), 1),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('softwareDisabledEdit.wildcardSection1Title')), 1),
                    _createElementVNode("div", _hoisted_8, [
                      _hoisted_9,
                      _createTextVNode(_toDisplayString(_ctx.$t('softwareDisabledEdit.wildcardStarDescription')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _hoisted_11,
                      _createTextVNode(_toDisplayString(_ctx.$t('softwareDisabledEdit.wildcardQuestionDescription')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('softwareDisabledEdit.wildcardSection2Title')), 1),
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _createTextVNode(_toDisplayString(_ctx.$t('softwareDisabledEdit.wildcardStarDescription')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _hoisted_17,
                      _createTextVNode(_toDisplayString(_ctx.$t('softwareDisabledEdit.wildcardQuestionDescription')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _hoisted_19,
                      _createTextVNode(_toDisplayString(_ctx.$t('softwareDisabledEdit.wildcardDoubleStarDescription')), 1)
                    ])
                  ])
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("i", null, [
                  _createVNode(_component_CmSvgIcon, {
                    name: "assets/icons/info-gray",
                    size: 18,
                    class: "wildcard-info-icon",
                    monochrome: "",
                    "aria-hidden": false,
                    "aria-label": "$t("
                  })
                ])
              ]),
              _: 1
            })
          ])
        ]),
        strategy_group_ids: _withCtx(() => [
          _createElementVNode("div", _hoisted_20, [
            _createVNode(PolicyBindScope, {
              "bind-mode": form.value.bind_mode ?? 0,
              "group-ids": form.value.strategy_group_ids || [],
              "device-ids": form.value.device_ids || [],
              "preset-group-id": presetGroupIdForPolicyBind.value,
              "permission-key": _unref(PermissionFe).soft_disable,
              "strategy-over": groupEditStrategyOver.value,
              disabled: !form.value.main_switch,
              "onUpdate:bindMode": _cache[3] || (_cache[3] = ($event: any) => (form.value.bind_mode = $event)),
              "onUpdate:groupIds": _cache[4] || (_cache[4] = ($event: any) => (form.value.strategy_group_ids = $event.map(String))),
              "onUpdate:deviceIds": _cache[5] || (_cache[5] = ($event: any) => (form.value.device_ids = $event)),
              onGroupUpdate: onGroupScopeUpdate
            }, null, 8, ["bind-mode", "group-ids", "device-ids", "preset-group-id", "permission-key", "strategy-over", "disabled"])
          ])
        ]),
        "strategy_group_ids-label": _withCtx(() => [
          _createElementVNode("div", {
            class: "cm-align-center",
            style: _normalizeStyle(_unref(formLabelStyle))
          }, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('policyBindScope.applyMode')), 1)
          ], 4)
        ]),
        _: 1
      }, 8, ["class", "form-size", "modelValue", "form-type", "form-columns", "disabled"])
    ]),
    _: 1
  })), [
    [_directive_loading, isLoading.value]
  ])
}
}

})